import React, { ReactElement, useState } from 'react';
import {
  Breadcrumbs, HiddenPriorityTitle, homeBreadcrumb, Message,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import { useClient } from '../../context/ClientStatusContext';
import VerzieModulov from '../../module/VerzieModulov/VerzieModulov';
import { getVerzieModulov } from '../../client/verzieModulovClient';

const VerzieModulovPage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getVerzieModulov(),
  );
  const [displayError, setDisplayError] = useState(true);

  return (
    <Layout>
      <HiddenPriorityTitle>Verzie modulov</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
          {
            to: routes.verziaSlovlexu.to,
            heading: routes.verziaSlovlexu.name,
          },
        ]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399) ? (
          <>
            {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať verzie modulov.
              </Message>
            )}
          </>
        )
          : (
            <VerzieModulov
              data={data}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default VerzieModulovPage;
